module.exports = __webpack_public_path__ + "static/media/8951.cb0cc608.jpg";